import React from "react";
import Button from "@mui/material/Button";
import FilterAltTwoToneIcon from "@mui/icons-material/FilterAltTwoTone";

interface FilterDesignsButtonProps {
  setMobileDesignFilterOpen: (isOpen: boolean) => void;
}

const FilterDesignsButton: React.FC<FilterDesignsButtonProps> = ({
  setMobileDesignFilterOpen: setMobileFilterOpen,
}) => {
  return (
    <div className="col-12 mb-3 mt-0 d-flex justify-content-end">
      <Button
        variant="outlined"
        startIcon={<FilterAltTwoToneIcon />}
        onClick={() => setMobileFilterOpen(true)}
        sx={{
          textTransform: "none",
          borderRadius: "8px",
          padding: "8px 16px",
          marginBottom: "16px",
        }}
      >
        Filter Designs
      </Button>
    </div>
  );
};

export default FilterDesignsButton;
